// extracted by mini-css-extract-plugin
module.exports = {"slider":"Inquiries_slider_ec_9l"};